module.exports = __webpack_public_path__ + "static/media/day.00950a96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/day.svg
// module id = 260
// module chunks = 0